module.exports = __webpack_public_path__ + "static/media/demon_sword.a258b5bf.png";